import { ItemMasterCriticalityCode } from '~/db_types/swagger_types';
export const ItemMasterCriticalityCodeDisplay = new Map([
    [ItemMasterCriticalityCode._1_1, '1/1: LOSS OF CREW OR VEHICLE/LOSS OF CREW OR VEHICLE'],
    [ItemMasterCriticalityCode._2_2, '2/2: LOSS OF MISSION/LOSS OF MISSION'],
    [ItemMasterCriticalityCode._3_3, '3/3: NO EFFECT/NO EFFECT'],
    [ItemMasterCriticalityCode._2_1R, '2/1R: LOSS OF MISSION/REDUNDANCY LOSS=LOSS OF CREW'],
    [ItemMasterCriticalityCode._3_1R, '3/1R: NO EFFECT/REDUNDANCY LOSS=LOSS OF CREW'],
    [ItemMasterCriticalityCode._3_2R, '3/2R: NO EFECT/REDUNDANCY LOSS=LOSS OF MISSION']
]);
export const ItemMasterCriticalityCodeNumberOnlyDisplay = new Map([
    [ItemMasterCriticalityCode._1_1, '1/1'],
    [ItemMasterCriticalityCode._2_2, '2/2'],
    [ItemMasterCriticalityCode._3_3, '3/3'],
    [ItemMasterCriticalityCode._2_1R, '2/1R'],
    [ItemMasterCriticalityCode._3_1R, '3/1R'],
    [ItemMasterCriticalityCode._3_2R, '3/2R']
]);
